import {
  ELEMENT_TAG_MAPPING,
  ELEMENT_TYPE_MAPPING,
  EMBED_TAG_MAPPING,
  PROBLEMATIC_SYMBOL_SAFE_MAPPING,
} from "@pages/Article/components/ArticleParagraphElements/utils/constants";
import { Type } from "@typings/enums";
import { DOMNode } from "html-react-parser";

/**
 * Determines the type of an HTML element based on its tag name and class attributes.
 * Returns a specific type if the element matches predefined mappings.
 */
export const getElementType = (node: DOMNode) => {
  if (node.type !== "tag") return;

  const tagName = node.name;
  const className = node.attribs?.class;

  const classList = className ? className.split(" ") : [];

  if (
    ELEMENT_TAG_MAPPING[tagName] &&
    classList.find((list) => ELEMENT_TYPE_MAPPING[list] === Type.BoxTitle)
  ) {
    return Type.BoxTitle;
  }

  if (ELEMENT_TAG_MAPPING[tagName]) {
    return ELEMENT_TAG_MAPPING[tagName];
  }

  if (!className) return;

  return classList.map((list) => ELEMENT_TYPE_MAPPING[list]).filter(Boolean)[0];
};

/**
 * Determines the embed type of an HTML element based on its class attributes.
 * Returns a specific embed type if the element matches predefined mappings.
 */
export const getEmbedType = (node: DOMNode) => {
  if (node.type !== "tag") return;

  const className = node.attribs?.class;
  if (!className) return;

  const classList = className.split(" ");

  return classList.map((list) => EMBED_TAG_MAPPING[list]).filter(Boolean)[0];
};

/**
 * Sanitizes and replaces problematic symbols in a given text.
 * This function is useful for cleaning up text content before rendering it in the UI.
 */
export const replaceProblematicSymbols = (text: string) => {
  if (!text) return text;

  return Object.keys(PROBLEMATIC_SYMBOL_SAFE_MAPPING).reduce(
    (acc, key) => acc.split(key).join(PROBLEMATIC_SYMBOL_SAFE_MAPPING[key]),
    text
  );
};
